module.exports = __webpack_public_path__ + "img/CoreEvent-logo-black.aef7f8aa.svg";